import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import apiUrl from '.';

const fetchProducts = createAsyncThunk(
    'product/fetchProducts',
    async (_, { rejectWithValue }) => {
        try {
            // const response={};
            const response2 = await axios.get(apiUrl+'/api/keeus/product'); // Update this URL with your actual endpoint
            console.log(response2)
            return response2.data.data.data;
            
            const response = await axios.get('https://allof.deprakoso.com/api/keeus/product');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

const fetchProduct = createAsyncThunk(
    'product/fetchProduct',
    async (orderId, { rejectWithValue }) => {
        try {
            const response = await axios.get(apiUrl+'/api/keeus/product'); // Update this URL with your actual endpoint
            const product = response.data.find(product => product.id === orderId);
            return product;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export { fetchProducts, fetchProduct };
